<script>
	import Fire from './../components/Fire.svelte';
	import PageTransition from "../components/PageTransition.svelte";
	import { Link } from "svelte-routing";
	import AOS from "aos";
	import "aos/dist/aos.css";
	AOS.init({
		// Global settings:
		disable: false, // accepts following values: 'phone', 'tablet', 'mobile', boolean, expression or function
		startEvent: "DOMContentLoaded", // name of the event dispatched on the document, that AOS should initialize on
		initClassName: "aos-init", // class applied after initialization
		animatedClassName: "aos-animate", // class applied on animation
		useClassNames: false, // if true, will add content of `data-aos` as classes on scroll
		disableMutationObserver: false, // disables automatic mutations' detections (advanced)
		debounceDelay: 50, // the delay on debounce used while resizing window (advanced)
		throttleDelay: 99, // the delay on throttle used while scrolling the page (advanced)

		// Settings that can be overridden on per-element basis, by `data-aos-*` attributes:
		offset: 120, // offset (in px) from the original trigger point
		delay: 0, // values from 0 to 3000, with step 50ms
		duration: 400, // values from 0 to 3000, with step 50ms
		easing: "ease", // default easing for AOS animations
		once: false, // whether animation should happen only once - while scrolling down
		mirror: false, // whether elements should animate out while scrolling past them
		anchorPlacement: "top-bottom", // defines which position of the element regarding to window should trigger the animation
	});
</script>
<head>
	<title>FyreHost | Cheap and Fast Server Hosting!</title>
	<meta name="description" content="FyreHost offers Cheap and Fast Minecraft, Factorio, Valheim, and Discord Bot Hosting ">
	<link rel="canonical" href="https://fyrehost.net" />
	<link rel='stylesheet' href='global.css'>
	<link rel='stylesheet' href='build/bundle.css'>
	<style>
		html {
			scroll-behavior: smooth;
		}
		
        /* width */
        ::-webkit-scrollbar {
            width: 10px;
        }

        /* Track */
        ::-webkit-scrollbar-track {
            background: #3B375E;
            /*border-radius: 10px;*/
        }

        /* Handle */
        ::-webkit-scrollbar-thumb {
            background: #68638D;
            border-radius: 10px;
        }

        /* Handle on hover */
        ::-webkit-scrollbar-thumb:hover {
            background: #9992BF;
        }
    
	</style>
</head>
<body>
	<PageTransition>
		<div style="background-color: #101032;">
			<div class="h-screen">
				<p
					class="w-full text-center text-gray-100 font-bold mt-52"
					style="	font-size: 10rem; line-height: 1;"
				>
					FyreHost
				</p>
				<br />
				<p
					class="w-full text-center text-gray-100 text-5xl font-extrabold"
				>
					Cheap and Fast Server Hosting
				</p>
				<div class="grid place-items-center mt-28">
					<div class="absolute" style="margin-top: 40rem/* 320px */;">
						<a href="#container">
							<Fire></Fire>
						</a>
					</div>
					
				</div>
			</div>
			
			<div class="h-full">
				<div
					style="position: relative; z-index: 5;"
					class="mx-auto -mt-44 w-3/4 h-3/4 fyrecontainer"
					id="container"
				>
					<img
						src="https://fyrehost.net/images/panel.png"
						alt=""
						class="mx-auto mt-10 shadow-3xl shadow-pink-500 hover:shadow-blue-500 rounded-lg p-2 bg-gradient-to-r from-yellow-400 via-red-500 to-pink-500"
					/>

					<div class="fyreoverlay">
						<div class="fyretext text-gray-100 text-9xl font-bold">
							FyrePanel
						</div>
					</div>
				</div>
			</div>
			

			<div
				class="flex flex-wrap overflow-hidden text-gray-100 text-lg list-none mt-10"
				style="position: relative; z-index: 5;"
			>
				<li
					class="mx-auto m-5 sm:mx-5 md:mx-auto sm:w-full md:w-1/6 overflow-hidden from-color1 to-color2 bg-gradient-to-r rounded-md shadow-2xl"
				>
					<div class="m-3 flex flex-wrap overflow-hidden">
						<div class="ml-auto overflow-hidden">
							<svg
								xmlns="http://www.w3.org/2000/svg"
								class="h-6 w-6"
								fill="none"
								viewBox="0 0 24 24"
								stroke="currentColor"
							>
								<path
									stroke-linecap="round"
									stroke-linejoin="round"
									stroke-width="2"
									d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"
								/>
							</svg>
						</div>

						<div class="mr-auto ml-2 overflow-hidden">
							<p>Full SFTP Access</p>
						</div>
					</div>
				</li>

				<li
					class="mx-auto m-5 sm:mx-5 md:mx-auto sm:w-full md:w-1/6 overflow-hidden from-color2 to-color3 bg-gradient-to-r rounded-md shadow-2xl"
				>
					<div class="m-3 flex flex-wrap overflow-hidden">
						<div class="ml-auto overflow-hidden">
							<svg
								xmlns="http://www.w3.org/2000/svg"
								class="h-6 w-6"
								fill="none"
								viewBox="0 0 24 24"
								stroke="currentColor"
							>
								<path
									stroke-linecap="round"
									stroke-linejoin="round"
									stroke-width="2"
									d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
								/>
							</svg>
						</div>

						<div class="mr-auto ml-2 overflow-hidden">
							<p>Unlimited Slots</p>
						</div>
					</div>
				</li>

				<li
					class="mx-auto m-5 sm:mx-5 md:mx-auto sm:w-full md:w-1/6 overflow-hidden from-color3 to-color4 bg-gradient-to-r rounded-md shadow-2xl"
				>
					<div class="m-3 flex flex-wrap overflow-hidden">
						<div class="ml-auto overflow-hidden">
							<svg
								xmlns="http://www.w3.org/2000/svg"
								class="h-6 w-6"
								fill="none"
								viewBox="0 0 24 24"
								stroke="currentColor"
							>
								<path
									stroke-linecap="round"
									stroke-linejoin="round"
									stroke-width="2"
									d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"
								/>
							</svg>
						</div>

						<div class="mr-auto ml-2 overflow-hidden">
							<p>Advanced DDos Protection</p>
						</div>
					</div>
				</li>

				<li
					class="mx-auto m-5 sm:mx-5 md:mx-auto sm:w-full md:w-1/6 overflow-hidden from-color4 to-color5 bg-gradient-to-r rounded-md shadow-2xl"
				>
					<div class="m-3 flex flex-wrap overflow-hidden">
						<div class="ml-auto overflow-hidden">
							<svg
								xmlns="http://www.w3.org/2000/svg"
								class="h-6 w-6"
								fill="none"
								viewBox="0 0 24 24"
								stroke="currentColor"
							>
								<path
									stroke-linecap="round"
									stroke-linejoin="round"
									stroke-width="2"
									d="M18.364 5.636l-3.536 3.536m0 5.656l3.536 3.536M9.172 9.172L5.636 5.636m3.536 9.192l-3.536 3.536M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-5 0a4 4 0 11-8 0 4 4 0 018 0z"
								/>
							</svg>
						</div>

						<div class="mr-auto ml-2 overflow-hidden">
							<p>24/7 Support</p>
						</div>
					</div>
				</li>

				<li
					class="mx-auto m-5 sm:mx-5 md:mx-auto sm:w-full md:w-1/6 overflow-hidden from-color5 to-color6 bg-gradient-to-r rounded-md shadow-2xl"
				>
					<div class="m-3 flex flex-wrap overflow-hidden">
						<div class="ml-auto overflow-hidden">
							<svg
								xmlns="http://www.w3.org/2000/svg"
								class="h-6 w-6"
								fill="none"
								viewBox="0 0 24 24"
								stroke="currentColor"
							>
								<path
									stroke-linecap="round"
									stroke-linejoin="round"
									stroke-width="2"
									d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
								/>
							</svg>
						</div>

						<div class="mr-auto ml-2 overflow-hidden">
							<p>99.9% Uptime</p>
						</div>
					</div>
				</li>
			</div>

			<br />
			<br />
			<br />
			<br />
			<div
				class="flex flex-wrap overflow-hidden mx-32 h-screen"
				data-aos="fade-up"
			>
				<div class="w-1/3 overflow-hidden my-auto">
					<svg
						xmlns="http://www.w3.org/2000/svg"
						x="0px"
						y="0px"
						class="mx-auto h-full w-full"
						viewBox="0 0 172 172"
						style="fill:#000000;"
						><g
							fill="none"
							fill-rule="nonzero"
							stroke="none"
							stroke-width="1"
							stroke-linecap="butt"
							stroke-linejoin="miter"
							stroke-miterlimit="10"
							stroke-dasharray=""
							stroke-dashoffset="0"
							font-family="none"
							font-weight="none"
							font-size="none"
							text-anchor="none"
							style="mix-blend-mode: normal"
							><path d="M0,172v-172h172v172z" fill="none" /><g
								fill="#ffffff"
								><path
									d="M51.6,17.2c-12.59782,0 -22.93333,10.33551 -22.93333,22.93333c0,10.6084 7.36282,19.52539 17.2,22.10469v6.56198v40.96198c-9.83718,2.5793 -17.2,11.4963 -17.2,22.10469c0,12.59782 10.33551,22.93333 22.93333,22.93333c12.59782,0 22.93333,-10.33551 22.93333,-22.93333c0,-10.60839 -7.36283,-19.52539 -17.2,-22.10469v-22.65339c0.85622,0.47616 1.73819,0.91192 2.63151,1.32136c7.48691,3.4315 16.34529,4.98744 24.87058,6.76354c8.52529,1.7761 16.66947,3.78342 21.98151,6.80833c3.85453,2.19493 6.23283,4.36589 7.25625,7.93932c-9.53389,2.78175 -16.60651,11.53382 -16.60651,21.92552c0,12.59782 10.33551,22.93333 22.93333,22.93333c12.59782,0 22.93333,-10.33551 22.93333,-22.93333c0,-10.81388 -7.63497,-19.91016 -17.75989,-22.28386c-1.59896,-7.94673 -6.78905,-13.95888 -13.09036,-17.54714c-7.58796,-4.32092 -16.64378,-6.25527 -25.31849,-8.0625c-8.67471,-1.80723 -17.01634,-3.47629 -22.42942,-5.95729c-2.70655,-1.2405 -4.5938,-2.63028 -5.71094,-4.02005c-1.11714,-1.38978 -1.69089,-2.75917 -1.69089,-5.19583v-6.56198c9.83717,-2.57929 17.2,-11.49629 17.2,-22.10469c0,-12.59782 -10.33551,-22.93333 -22.93333,-22.93333zM51.6,28.66667c6.40077,0 11.46667,5.06589 11.46667,11.46667c0,6.22369 -4.80246,11.14091 -10.95156,11.41068c-0.20103,-0.0181 -0.40287,-0.02558 -0.60469,-0.0224c-0.1458,0.00191 -0.29148,0.00938 -0.43672,0.0224c-6.14367,-0.27534 -10.94036,-5.19079 -10.94036,-11.41068c0,-6.40077 5.06589,-11.46667 11.46667,-11.46667zM51.0849,120.45599c0.34642,0.03159 0.69499,0.03159 1.04141,0c6.14367,0.27534 10.94036,5.19079 10.94036,11.41067c0,6.40077 -5.06589,11.46667 -11.46667,11.46667c-6.40077,0 -11.46667,-5.06589 -11.46667,-11.46667c0,-6.22369 4.80246,-11.1409 10.95156,-11.41067zM119.88489,120.45599c0.34642,0.03159 0.69499,0.03159 1.04141,0c6.14367,0.27534 10.94036,5.19079 10.94036,11.41067c0,6.40077 -5.06589,11.46667 -11.46667,11.46667c-6.40077,0 -11.46667,-5.06589 -11.46667,-11.46667c0,-6.22369 4.80246,-11.1409 10.95156,-11.41067z"
								/></g
							></g
						>
					</svg>
				</div>

				<div class="w-2/3 overflow-hidden my-auto">
					<p class="text-8xl text-white font-bold text-center">
						Version Control
					</p>
					<img
						src="https://i.imgur.com/GVyVbGU.png"
						alt="Version Control"
						class="mx-auto my-10 w-5/6 shadow-3xl shadow-indigo-500 rounded-lg p-2 bg-gradient-to-r from-white via-blue-300 to-blue-700"
					/>
				</div>
			</div>

			<div
				class="flex flex-wrap overflow-hidden mx-32 h-screen"
				data-aos="fade-up"
			>
				<div class="w-2/3 overflow-hidden my-auto">
					<p class="text-8xl text-white font-bold text-center">
						Free Backups
					</p>
					<img
						src="https://i.imgur.com/rYxxFFb.png"
						alt="Free Backups"
						class="mx-auto my-10 shadow-3xl shadow-violet-500 rounded-lg p-2"
						style="background-color: #4158D0;
					background-image: linear-gradient(43deg, #4158D0 0%, #C850C0 46%, #FFCC70 100%);
					"
					/>
				</div>

				<div class="w-1/3 overflow-hidden my-auto">
					<svg
						xmlns="http://www.w3.org/2000/svg"
						class="mx-auto h-full w-full"
						fill="none"
						viewBox="0 0 24 24"
						stroke="white"
					>
						<path
							stroke-linecap="round"
							stroke-linejoin="round"
							stroke-width="2"
							d="M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-9 4h4"
						/>
					</svg>
				</div>
			</div>

			<div
				class="flex flex-wrap overflow-hidden mx-32 h-screen"
				data-aos="fade-up"
			>
				<div class="w-1/3 overflow-hidden my-auto">
					<svg
						xmlns="http://www.w3.org/2000/svg"
						class="mx-auto h-full w-full"
						fill="none"
						viewBox="0 0 24 24"
						stroke="white"
					>
						<path
							strokeLinecap="round"
							strokeLinejoin="round"
							strokeWidth={2}
							d="M4 7v10c0 2.21 3.582 4 8 4s8-1.79 8-4V7M4 7c0 2.21 3.582 4 8 4s8-1.79 8-4M4 7c0-2.21 3.582-4 8-4s8 1.79 8 4m0 5c0 2.21-3.582 4-8 4s-8-1.79-8-4"
						/>
					</svg>
				</div>

				<div class="w-2/3 overflow-hidden my-auto">
					<p class="text-8xl text-white font-bold text-center">
						Free Databases
					</p>
					<img
						src="https://i.imgur.com/I4ZLAhG.png"
						alt="Free Databases"
						class="mx-auto my-10 shadow-3xl shadow-violet-500 rounded-lg p-2"
						style="background-color: #00DBDE;
					background-image: linear-gradient(90deg, #00DBDE 0%, #FC00FF 100%);
					"
					/>
				</div>
			</div>

			<div class="py-12 h-screen" data-aos="fade-up">
				<div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
					<div class="lg:text-center">
						<p
							class="mt-2 text-7xl text-transparent bg-clip-text  bg-gradient-to-r from-indigo-500 to-indigo-700 leading-8 font-extrabold tracking-tight  sm:text-7xl"
						>
							A Better Way to Host
						</p>
						<p
							class="mt-4 max-w-2xl text-2xl text-gray-500 lg:mx-auto"
						>
							Get better hosting at a lower cost.
						</p>
					</div>

					<div class="mt-10">
						<dl
							class="space-y-10 md:space-y-0 md:grid md:grid-cols-2 md:gap-x-8 md:gap-y-10"
						>
							<div class="relative">
								<dt>
									<div
										class="absolute flex items-center justify-center h-12 w-12 rounded-md bg-gradient-to-r from-blue-400 to-blue-500 hover:from-red-500 hover:to-yellow-500 text-white"
									>
										<svg
											class="h-6 w-6"
											xmlns="http://www.w3.org/2000/svg"
											fill="none"
											viewBox="0 0 24 24"
											stroke="currentColor"
											aria-hidden="true"
										>
											<path
												stroke-linecap="round"
												stroke-linejoin="round"
												stroke-width="2"
												d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9"
											/>
										</svg>
									</div>
									<p
										class="ml-16 text-xl leading-6 font-medium text-white"
									>
										Full Support
									</p>
								</dt>
								<dd class="mt-2 ml-16 text-base text-gray-300">
									Want to install a modpack, but don't know how? Created a ticket in our Discord and we'll do it for you! 
									Our support staff is always here to help you out.
								</dd>
							</div>

							<div class="relative">
								<dt>
									<div
										class="absolute flex items-center justify-center h-12 w-12 rounded-md bg-gradient-to-r from-green-400 to-green-600 hover:from-red-500 hover:to-yellow-500 text-white"
									>
										<svg
											class="h-6 w-6"
											xmlns="http://www.w3.org/2000/svg"
											fill="none"
											viewBox="0 0 24 24"
											stroke="currentColor"
											aria-hidden="true"
										>
											<path
												stroke-linecap="round"
												stroke-linejoin="round"
												stroke-width="2"
												d="M3 6l3 1m0 0l-3 9a5.002 5.002 0 006.001 0M6 7l3 9M6 7l6-2m6 2l3-1m-3 1l-3 9a5.002 5.002 0 006.001 0M18 7l3 9m-3-9l-6-2m0-2v2m0 16V5m0 16H9m3 0h3"
											/>
										</svg>
									</div>
									<p
										class="ml-16 text-xl leading-6 font-medium text-white"
									>
										The best value
									</p>
								</dt>
								<dd class="mt-2 ml-16 text-base text-gray-300">
									Unlike other hosts, we have built our
									infrastructure from the ground up to offer
									the lowest cost hosting solutions while
									still offering the best experience to our
									customers!
								</dd>
							</div>

							<div class="relative">
								<dt>
									<div
										class="absolute flex items-center justify-center h-12 w-12 rounded-md bg-gradient-to-r from-gray-400 to-gray-500 hover:from-red-500 hover:to-yellow-500 text-white"
									>
										<svg
											xmlns="http://www.w3.org/2000/svg"
											class="h-6 w-6"
											fill="none"
											viewBox="0 0 24 24"
											stroke="currentColor"
										>
											<path
												stroke-linecap="round"
												stroke-linejoin="round"
												stroke-width="2"
												d="M5 12h14M5 12a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v4a2 2 0 01-2 2M5 12a2 2 0 00-2 2v4a2 2 0 002 2h14a2 2 0 002-2v-4a2 2 0 00-2-2m-2-4h.01M17 16h.01"
											/>
										</svg>
									</div>
									<p
										class="ml-16 text-xl leading-6 font-medium text-white"
									>
										Hardware
									</p>
								</dt>
								<dd class="mt-2 ml-16 text-base text-gray-300">
									Our server hardware was selected to offer
									the best game server experience, unlike
									other hosts which use the same servers for
									everything.
								</dd>
							</div>

							<div class="relative">
								<dt>
									<div
										class="absolute flex items-center justify-center h-12 w-12 rounded-md bg-gradient-to-r from-blue-400 to-blue-500 hover:from-red-500 hover:to-yellow-500 text-white"
									>
										<svg
											xmlns="http://www.w3.org/2000/svg"
											class="h-5 w-5"
											viewBox="0 0 20 20"
											fill="currentColor"
										>
											<path
												d="M5 4a1 1 0 00-2 0v7.268a2 2 0 000 3.464V16a1 1 0 102 0v-1.268a2 2 0 000-3.464V4zM11 4a1 1 0 10-2 0v1.268a2 2 0 000 3.464V16a1 1 0 102 0V8.732a2 2 0 000-3.464V4zM16 3a1 1 0 011 1v7.268a2 2 0 010 3.464V16a1 1 0 11-2 0v-1.268a2 2 0 010-3.464V4a1 1 0 011-1z"
											/>
										</svg>
									</div>
									<p
										class="ml-16 text-xl leading-6 font-medium text-white"
									>
										Control your server better
									</p>
								</dt>
								<dd class="mt-2 ml-16 text-base text-gray-300">
									We have engineered our solution to add
									features like version control and backups,
									along with the addition of PhpMyAdmin to
									enhance the control you have over your
									server!
								</dd>
							</div>
							<div class="relative">
								<dt>
									<div
										class="absolute flex items-center justify-center h-12 w-12 rounded-md bg-gradient-to-r from-blue-400 to-blue-500 hover:from-red-500 hover:to-yellow-500 text-white"
									>
										<svg
											xmlns="http://www.w3.org/2000/svg"
											class="h-6 w-6"
											fill="none"
											viewBox="0 0 24 24"
											stroke="currentColor"
										>
											<path
												stroke-linecap="round"
												stroke-linejoin="round"
												stroke-width="2"
												d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z"
											/>
										</svg>
									</div>
									<p
										class="ml-16 text-xl leading-6 font-medium text-white"
									>
										Files
									</p>
								</dt>
								<dd class="mt-2 ml-16 text-base text-gray-300">
									Manage your server execution better with our
									file management and version control
									solutions.
								</dd>
							</div>

							<div class="relative">
								<dt>
									<div
										class="absolute flex items-center justify-center h-12 w-12 rounded-md bg-gradient-to-r from-gray-400 to-gray-500 hover:from-red-500 hover:to-yellow-500 text-white"
									>
										<svg
											xmlns="http://www.w3.org/2000/svg"
											class="h-6 w-6"
											fill="none"
											viewBox="0 0 24 24"
											stroke="currentColor"
										>
											<path
												stroke-linecap="round"
												stroke-linejoin="round"
												stroke-width="2"
												d="M18.364 5.636l-3.536 3.536m0 5.656l3.536 3.536M9.172 9.172L5.636 5.636m3.536 9.192l-3.536 3.536M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-5 0a4 4 0 11-8 0 4 4 0 018 0z"
											/>
										</svg>
									</div>
									<p
										class="ml-16 text-xl leading-6 font-medium text-white"
									>
										Support
									</p>
								</dt>
								<dd class="mt-2 ml-16 text-base text-gray-300">
									Our support team is readily accessible
									through discord for the fastest experience
									possible, don't wait for email support to
									respond any longer!
								</dd>
							</div>
							<div class="relative">
								<dt>
									<div
										class="absolute flex items-center justify-center h-12 w-12 rounded-md bg-gradient-to-r from-red-400 to-red-500 hover:from-red-500 hover:to-yellow-500 text-white"
									>
										<svg
											xmlns="http://www.w3.org/2000/svg"
											class="h-6 w-6"
											fill="none"
											viewBox="0 0 24 24"
											stroke="currentColor"
										>
											<path
												stroke-linecap="round"
												stroke-linejoin="round"
												stroke-width="2"
												d="M5.636 18.364a9 9 0 010-12.728m12.728 0a9 9 0 010 12.728m-9.9-2.829a5 5 0 010-7.07m7.072 0a5 5 0 010 7.07M13 12a1 1 0 11-2 0 1 1 0 012 0z"
											/>
										</svg>
									</div>
									<p
										class="ml-16 text-xl leading-6 font-medium text-white"
									>
										SLA
									</p>
								</dt>
								<dd class="mt-2 ml-16 text-base text-gray-300">
									We offer a 99.9% uptime SLA, if your server
									goes down, we will reimburse you!
								</dd>
							</div>

							<div class="relative">
								<dt>
									<div
										class="absolute flex items-center justify-center h-12 w-12 rounded-md bg-gradient-to-r from-yellow-400 to-yellow-500 hover:from-red-500 hover:to-yellow-500 text-white"
									>
										<svg
											class="h-6 w-6"
											xmlns="http://www.w3.org/2000/svg"
											fill="none"
											viewBox="0 0 24 24"
											stroke="currentColor"
											aria-hidden="true"
										>
											<path
												stroke-linecap="round"
												stroke-linejoin="round"
												stroke-width="2"
												d="M13 10V3L4 14h7v7l9-11h-7z"
											/>
										</svg>
									</div>
									<p
										class="ml-16 text-xl leading-6 font-medium text-white"
									>
										Fast Provisioning
									</p>
								</dt>
								<dd class="mt-2 ml-16 text-base text-gray-300">
									Start playing in less than 10 minutes after
									purchasing, no need to wait for your server
									to get ready!
								</dd>
							</div>
						</dl>
					</div>
				</div>
			</div>

			<div class="h-screen">
				<div class="flex flex-wrap overflow-hidden mx-auto">
					<div
						data-aos="flip-left"
						class="w-full overflow-hidden md:w-1/2 lg:w-1/2 xl:w-1/2 mx-auto"
					>
						<Link to="minecraft">
							<img
								src="images/0b5uZKH.webp"
								class="w-4/5 mx-auto my-10 shadow-3xl rounded-lg p-2"
								alt="minecraft"
								style="background-color: #21D4FD;
							background-image: linear-gradient(19deg, #21D4FD 0%, #B721FF 100%);
							"
							/>
						</Link>
					</div>

					<div
						data-aos="flip-right"
						class="w-full overflow-hidden md:w-1/2 lg:w-1/2 xl:w-1/2 mx-auto"
					>
						<Link to="factorio">
							<img
								src="images/dPUuDgu.webp"
								class="w-4/5 mx-auto my-10 shadow-3xl rounded-lg p-2 "
								alt="factorio"
								style="background-color: #FA8BFF;
							background-image: linear-gradient(45deg, #FA8BFF 0%, #2BD2FF 52%, #2BFF88 90%);
							"
							/>
						</Link>
					</div>

					<div
						data-aos="flip-left"
						class="w-full overflow-hidden md:w-1/2 lg:w-1/2 xl:w-1/2 mb-10 mx-auto"
					>
						<Link to="valheim">
							<img
								src="images/biuF8sY.webp"
								class="w-4/5 mx-auto my-10 shadow-3xl rounded-lg p-2"
								alt="valheim"
								style="background-image: radial-gradient( circle farthest-corner at 10% 20%,  rgba(255,94,247,1) 17.8%, rgba(2,245,255,1) 100.2% );"
							/>
						</Link>
					</div>

					<div
						data-aos="flip-right"
						class="w-full overflow-hidden md:w-1/2 lg:w-1/2 xl:w-1/2 mb-10 mx-auto"
					>
						<Link to="discord">
							<img
								src="images/1gRJMZ7.webp"
								class="w-4/5 mx-auto my-10 shadow-3xl rounded-lg p-2"
								alt="discord"
								style="background-image: linear-gradient( 109.6deg,  rgba(61,245,167,1) 11.2%, rgba(9,111,224,1) 91.1% );"
							/>
						</Link>
					</div>
				</div>
			</div>
		</div>
	</PageTransition>
</body>
